import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class PrestadorService {

    async listPrestadores(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('prestador');
        const idPrestador = RoleService.getPrestador();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllPrestadores(iss);
            case 'COMPANY':
                return this.listAllPrestadores(iss);
            case 'SELF':
                return this.getPrestador(iss, idPrestador);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    listAllPrestadores(data) {
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get`)
    }

    getPrestador(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get/${id}`, {
            params: params
        })
    }

    getPrestadorFilter(data, search) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/prestador/${data}/get?${search}`, {
            params: params
        })
    }

    postPrestador(data, prestador) {
        return axiosInstance.post(`${config.api.version}/prestador/${data}/`, prestador)
    }

    putPrestador(data, prestador, id) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/${id}`, prestador)
    }

    deletePrestador(data, id) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/delete/${id}`)
    }

    activePrestador(data, id, status) {
        return axiosInstance.put(`${config.api.version}/prestador/${data}/active/${id}/${status}`)
    }
}